<template>
  <div>
    <div id="product-content" v-if="isProductLoaded">
      <div class="product-top-bar">
        <div class="container-fluid">
          <div class="row align-items-center py-2 py-md-0">
            <div class="col">
              <h2 class="text-white title m-0 text-uppercase" v-html="product.title.rendered"></h2>
            </div>
            <div class="col d-flex justify-content-end">
              <ul class="nav">
                <li class="nav-item d-none d-lg-block"><a href="#" class="nav-link" v-scroll-to="'.product-content-container'" v-html="$t('message.overview')"></a></li>
                <li class="nav-item d-none d-lg-block"><a href="#" class="nav-link" v-scroll-to="'#product-components'" v-html="$t('message.productdetail')"></a></li>
                <li class="nav-item d-none d-lg-block"><a href="#" class="nav-link" v-scroll-to="'#warranty'" v-html="$t('message.warranty')"></a></li>
                <li class="nav-item ml-lg-4" v-if="product.acf.product_url"><a :href="product.acf.product_url" class="btn white small" target="_blank" v-html="$t('message.buy')"></a></li>
              </ul>
            </div>
          </div>
        </div>
        <!-- /.container-fluid -->
      </div>
      <div class="container-fluid" ref="contentElement">
        <div class="product-content-container" v-html="product.content.rendered"></div>
      </div>
      <!-- Related Product -->
      <section class="related-product py-5" v-if="isRelatedProductLoaded && relatedProducts.length">
        <div class="container">
          <h1 class="page-title mb-4 text-capitalize" v-html="`สินค้าอื่น ๆ ใน ${product._embedded['wp:term'][0][0].name}`"></h1>

          <!-- Swiper -->
          <swiper :options="swiperOption">
            <swiper-slide v-for="related in relatedProducts" :key="related.id" class="product-card-container">
              <div class="product-card white">
                <router-link :to="{ name: related.type, params: { slug: related.slug } }">
                  <div class="product-thumbnail">
                    <div class="product-media">
                      <img :src="related._embedded['wp:featuredmedia'][0].media_details.sizes['medium'].source_url" class="img-fluid" :alt="related._embedded['wp:featuredmedia'][0].alt_text">
                    </div>
                  </div>
                  <div class="product-detail">
                    <div class="product-title" v-html="related.title.rendered"></div>
                  </div>
                </router-link>
              </div>
            </swiper-slide>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
          </swiper>
        </div>
      </section>
      <!-- /.related-product -->
      <div class="container py-5" id="warranty" v-if="isWarrantyLoaded">
        <h1 class="page-title mb-4" v-html="warrantyContent.title.rendered"></h1>
        <div v-html="warrantyContent.content.rendered"></div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { TimelineLite, Power0 } from 'gsap'
import JQuery from 'jquery'
const Flickity = require('flickity')
export default {
  name: 'Product',
  components: {
    swiper,
    swiperSlide
  },
  data () {
    return {
      api_path: process.env.VUE_APP_API_PATH,
      title: process.env.VUE_APP_TITLE,
      product: [],
      isProductLoaded: false,
      relatedProducts: [],
      isRelatedProductLoaded: false,
      warrantyContent: [],
      isWarrantyLoaded: false,
      swiperOption: {
        slidesPerView: 3,
        spaceBetween: 30,
        loop: false,
        loopFillGroupWithBlank: false,
        mousewheel: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        breakpoints: {
          992: {
            slidesPerView: 'auto',
            spaceBetween: 15
          },
          768: {
            slidesPerView: 'auto',
            spaceBetween: 15
          }
        }
      },
      heroTween: new TimelineLite({ paused: true })
    }
  },
  mounted () {
    this.getProduct()
  },
  methods: {
    getProduct () {
      const slug = this.$route.params.slug
      const lang = this.$route.params.lang
      const $vm = this
      $vm.isProductLoaded = false
      axios.get(`${this.api_path}wp-json/wp/v2/product`, {
        params: {
          slug,
          lang,
          _embed: true
        }
      })
        .then(res => {
          if (res.data) {
            $vm.product = res.data[0]
            $vm.isProductLoaded = true
            document.title = `${$vm.product.title.rendered} - ${$vm.title}`
            $vm.getRelatedProduct($vm.product._embedded['wp:term'][0][0].id, $vm.product.id)
            $vm.getWarranty()
            setTimeout(() => {
              $vm.animated()
            }, 100)
            const $ = JQuery
            setTimeout(() => {
              if ($('.has-carousel')) {
                $('.has-carousel').each(function (i) {
                  var options = JSON.parse($(this).attr('data-flickity'))
                  const carousel = new Flickity($('.has-carousel')[i], options)
                  if (carousel) {}
                })
              }
            }, 100)
          }
        })
    },
    getRelatedProduct (categories, exclude) {
      const $vm = this
      axios.get(`${this.api_path}wp-json/wp/v2/product`, {
        params: {
          _embed: true,
          categories,
          exclude
        }
      })
        .then(res => {
          if (res.data) {
            $vm.relatedProducts = res.data
            $vm.isRelatedProductLoaded = true
          }
        })
    },
    animated () {
      const { contentElement } = this.$refs
      this.heroTween
        .staggerTo(contentElement, 0.3, { opacity: 1, y: 100, ease: Power0.easeOut }, 0.04)
        .play()
    },
    getWarranty () {
      const $vm = this
      const lang = this.$route.params.lang
      axios.get(`${this.api_path}wp-json/wp/v2/pages`, {
        params: {
          slug: 'warranty',
          lang
        }
      })
        .then(res => {
          if (res.data) {
            $vm.warrantyContent = res.data[0]
            $vm.isWarrantyLoaded = true
          }
        })
    }
  },
  watch: {
    '$route' () {
      this.getProduct()
    }
  }
}
</script>
